module.exports = __webpack_public_path__ + "static/img/01038B_2_C_20230531_fit.0044986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_2_C_20230531_fit.png
// module id = h9Wf
// module chunks = 0